import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana6Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1466_34711)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M638.754 432.647L565.628 428.694L547.841 440.553L585.392 503.796L650.612 464.269C655.356 442.134 644.683 433.965 638.754 432.647Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M524.12 539.367L585.388 503.793L547.837 440.549L488.545 476.123L524.12 539.367Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M464.83 570.992L524.122 539.37L488.547 476.126L431.232 505.772L464.83 570.992Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M399.611 600.641L464.831 570.996L431.233 505.775L367.989 535.421L399.611 600.641Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M344.272 630.282L399.611 600.636L367.989 535.416L318.58 559.132V620.4C326.485 629.886 339.002 630.941 344.272 630.282Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M452.975 420.79L565.628 428.696L547.841 440.554L488.55 476.128L445.07 497.868L452.975 420.79Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M393.678 414.859L452.97 420.788L445.064 497.867L431.229 505.772L393.678 523.56V414.859Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M336.367 408.93L393.682 414.859V476.127H318.58V422.765C320.161 410.116 331.097 408.271 336.367 408.93Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M318.58 559.134V476.126H393.682V521.582L367.989 535.417L318.58 559.134Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1466_34711" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1466_34711" transform="matrix(0.00271092 0 0 0.00359396 -5.69248 -0.730606)"/>
    </pattern>
    <image id="image0_1466_34711" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};